import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import { noOp } from "../util/Interface";
/**
 * TransportEvent is an internal class used by [[Transport]]
 * to schedule events. Do no invoke this class directly, it is
 * handled from within Tone.Transport.
 */

export var TransportEvent = /*#__PURE__*/function () {
  /**
   * @param transport The transport object which the event belongs to
   */
  function TransportEvent(transport, opts) {
    _classCallCheck(this, TransportEvent);

    /**
     * The unique id of the event
     */
    this.id = TransportEvent._eventId++;
    var options = Object.assign(TransportEvent.getDefaults(), opts);
    this.transport = transport;
    this.callback = options.callback;
    this._once = options.once;
    this.time = options.time;
  }

  _createClass(TransportEvent, [{
    key: "invoke",
    value:
    /**
     * Invoke the event callback.
     * @param  time  The AudioContext time in seconds of the event
     */
    function invoke(time) {
      if (this.callback) {
        this.callback(time);

        if (this._once) {
          this.transport.clear(this.id);
        }
      }
    }
    /**
     * Clean up
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this.callback = undefined;
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return {
        callback: noOp,
        once: false,
        time: 0
      };
    }
  }]);

  return TransportEvent;
}();
/**
 * Current ID counter
 */

TransportEvent._eventId = 0;